import React, { FC } from 'react'

export type Props = {
  itemImage: string | null
  backgroundImage: string | null
}

export const Image: FC<Props> = ({ itemImage, backgroundImage }) => {
  return (
    <div className="Visualizer-block">
      <div
        className="Visualizer-background"
        style={{
          backgroundImage: backgroundImage
            ? `url('${backgroundImage}')`
            : undefined
        }}
      >
        <div
          style={{
            backgroundImage: itemImage ? `url('${itemImage}')` : undefined
          }}
          className="Visualizer-imgItem"
        ></div>
      </div>
    </div>
  )
}
